export default "__VITE_ASSET__CTJ4lqa2__"